import { render, staticRenderFns } from "./HeightenedPerspective.vue?vue&type=template&id=c6730038&scoped=true&"
var script = {}
import style0 from "./HeightenedPerspective.vue?vue&type=style&index=0&id=c6730038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6730038",
  null
  
)

export default component.exports